import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { onlyNumber } from "../../constant/utils";
import { validateGeneralEnquiry } from "../../constant/validation";
import { dashboardAction, submitAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SeoAdd from "../Seo/SeoAdd";
import { useTranslation } from "react-i18next";
import Recaptcha from "../ReCaptcha";

const initialValue = {
  Name: "",
  Email: "",
  Mobile: "",
  Message: "",
  CityId: "",
  UtmSource: "",
  UtmMedium: "",
  UtmCampaign: "",
  Checkbox: false,
  GRecaptcha: "",
};

function GeneralEnquiry() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const cityData = useSelector((state: any) => state.dashboard.cityAll);
  const loading = useSelector((state: any) => state.common.loader);
  useEffect(() => {
    window?.scrollTo(0, 0);
    return () => {};
  }, []);

  const handleSubmit = (values: any) => {
    let val: any = { ...values };
    val.SourceUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    val.UtmSource = urlParams.get("utm_source");
    val.UtmMedium = urlParams.get("utm_medium");
    val.UtmCampaign = urlParams.get("utm_campaign");
    dispatch(submitAction.submitEnquiryAction(val, history));
  };

  return (
    <>
      <SeoAdd slug={ROUTE.GENERALENQUIRY} />
      <BreadCrumb page={t("enquiry")} />
      <section className="thank-section bg-color">
        <div className="container">
          <div
            className="tab-content bgFormImage"
            style={{
              backgroundImage: "url(/assets/img/general_query_banner.png)",
            }}
          >
            <div id="organs" className="tab-pane fade in active show">
              <div className="row prescription-card">
                <div className="col-sm-12 col-md-7 col-xl-4 col-lg-6">
                  <Formik
                    initialValues={initialValue}
                    enableReinitialize={true}
                    validationSchema={validateGeneralEnquiry}
                    onSubmit={(val: any) => {
                      handleSubmit(val);
                    }}
                    render={({
                      values,
                      handleChange,
                      errors,
                      touched,
                      handleBlur,
                      handleSubmit,
                      setFieldValue,
                    }: any) => (
                      <form onSubmit={handleSubmit}>
                        <div className="h-services gen-form-Pb">
                          <div className="infobox_wrapper">
                            <h3 className="mr-10">{t("enquiry")}</h3>
                            <div className="ln-1 mr-10">
                              {t("neurology_form_note")}
                            </div>
                            <div className="form-group">
                              <input
                                type="text"
                                name="Name"
                                className="form-control"
                                placeholder={t("name")}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.Name}
                              />
                              {touched?.Name && errors?.Name && (
                                <span className="error_message">
                                  {t(errors?.Name)}
                                </span>
                              )}
                            </div>
                            <div className="form-group">
                              <input
                                type="text"
                                name="Mobile"
                                className="form-control"
                                placeholder={t("mobile_number")}
                                onKeyPress={onlyNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.Mobile}
                              />
                              {touched?.Mobile && errors?.Mobile && (
                                <span className="error_message">
                                  {t(errors?.Mobile)}
                                </span>
                              )}
                            </div>
                            <div className="form-group">
                              <select
                                className="form-control"
                                name="CityId"
                                id="CityId"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.CityId}
                              >
                                <option value="">{t("city")}*</option>
                                {cityData &&
                                  cityData.length > 0 &&
                                  cityData?.map((item: any, i: any) => (
                                    <option
                                      value={item?.Id}
                                      key={i}
                                      className="text-uppercase"
                                    >
                                      {t(item?.Name)}
                                    </option>
                                  ))}
                              </select>
                              {touched?.CityId && errors?.CityId && (
                                <span className="error_message">
                                  {t(errors?.CityId)}
                                </span>
                              )}
                            </div>
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                placeholder={t("email")}
                                name="Email"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.Email}
                              />
                              {touched?.Email && errors?.Email && (
                                <span className="error_message">
                                  {errors?.Email}
                                </span>
                              )}
                            </div>
                            <div className="form-group">
                              <textarea
                                className="form-control"
                                placeholder={t("message")}
                                name="Message"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.Message}
                              ></textarea>
                              {touched?.Message && errors?.Message && (
                                <span className="error_message">
                                  {t(errors?.Message)}
                                </span>
                              )}
                            </div>
                            <div className="d-flex for-check-style">
                              <input
                                type="checkbox"
                                name="Checkbox"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                id="checkbox_id"
                              />
                              <label
                                className="mx-2 mb-0"
                                htmlFor="checkbox_id"
                              >
                                By clicking you accept to the{" "}
                                <a
                                  className="text-info"
                                  href="https://oncquestlabs.com/terms-condition"
                                >
                                  terms and conditions
                                </a>{" "}
                                and the{" "}
                                <a
                                  className="text-info"
                                  href="https://oncquestlabs.com/privacy-policy"
                                >
                                  Privacy Policy.
                                </a>
                              </label>
                            </div>
                            <div>
                              {touched?.Checkbox && errors?.Checkbox && (
                                <span className="error_message">
                                  {errors?.Checkbox}
                                </span>
                              )}
                            </div>
                            <div className="form-group">
                              <Recaptcha
                                touch={touched?.GRecaptcha}
                                error={errors?.GRecaptcha}
                                onChange={(token: any) =>
                                  setFieldValue("GRecaptcha", token)
                                }
                                onExpired={() =>
                                  setFieldValue("GRecaptcha", "")
                                }
                              />
                            </div>
                            <button
                              type="submit"
                              className="book--hexagon active"
                              disabled={loading}
                            >
                              <span>
                                {loading ? (
                                  <>
                                    Submitting...
                                    <i className="fa fa-spinner fa-spin ml-20"></i>
                                  </>
                                ) : (
                                  <>
                                    {t("submit_btn")}
                                    <i
                                      className="fa fa-long-arrow-right ml-20"
                                      aria-hidden="true"
                                    ></i>
                                  </>
                                )}
                              </span>
                            </button>
                          </div>
                        </div>
                      </form>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default GeneralEnquiry;
